import script from "./NewsScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsScreen.vue?vue&type=script&setup=true&lang=js"

import "./NewsScreen.vue?vue&type=style&index=0&id=519bc594&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-519bc594"]])

export default __exports__